import React from 'react';
import { connect } from 'react-redux';
import { getClient } from 'features/clientProfile/ducks/clientProfileActions';
import AssessmentForm from './AssessmentForm';
import { updateAssessment, getAssessment } from './ducks/AssessmentActions';
import formValuesSchema from './AssessmentForm/formValuesSchema';
import { mapping as heightMapping } from './AssessmentForm/form/HeightField';
import { mapping as bFPMapping } from './AssessmentForm/form/BodyFatPercentageField';

class EditAssessment extends React.Component {
  constructor(props) {
    super(props);

    this.clientId = props.match.params.client_id;
    this.assessmentId = props.match.params.id;
  }

  componentDidMount() {
    let { history } = this.props;
    this.props.getClient(this.clientId, history);
    this.props.getAssessment(this.assessmentId, history);
  }

  formInitVals = assessment => {
    return {
      id: this.assessmentId,
      created_at: assessment.created_at,
      assessment_type: assessment.assessment_type,
      client_id: assessment.client_id,
      trainer_id: assessment.trainer_id,
      gender: assessment.gender,
      weight: assessment.weight,
      measurements: assessment.measurements,
      progress_photos: {
        front: {
          url: assessment.progress_photos && assessment.progress_photos.front ?
            assessment.progress_photos.front : '',
          size: 0
        },
        side: {
          url: assessment.progress_photos && assessment.progress_photos.side ?
            assessment.progress_photos.side : '',
          size: 0
        },
        back: {
          url: assessment.progress_photos && assessment.progress_photos.back ?
            assessment.progress_photos.back : '',
          size: 0
        }
      },

      birthdate: {
        month: Number(assessment.birthday.getMonth()) + 1,
        day: Number(assessment.birthday.getDate()),
        year: Number(assessment.birthday.getFullYear())
      },

      height: this.heightKeys(assessment),

      body_fat_percentage: this.bFPKeys(assessment),

      ...(assessment.assessment_type === 'First Session' &&
        this.movementKeys(assessment))
    };
  };

  heightKeys = assessment => {
    return {
      unit: assessment.height.measurement_unit,
      cm:
        assessment.height.measurement_unit === heightMapping.metricUnit.value
          ? assessment.height.value
          : '',
      feet:
        assessment.height.measurement_unit === heightMapping.imperialUnit.value
          ? Math.floor(assessment.height.value)
          : '',
      inch:
        assessment.height.measurement_unit === heightMapping.imperialUnit.value
          ? Math.round(
              (Number(assessment.height.value) -
                Math.floor(assessment.height.value)) *
                12
            )
          : ''
    };
  };

  bFPKeys = assessment => {
    return {
      ...formValuesSchema.body_fat_percentage,
      method: assessment.body_fat_percentage_is_text
        ? bFPMapping.textMethod.value
        : bFPMapping.caliperMethod.value,
      caliperMethod: assessment.jp3
        ? bFPMapping.caliperMethod.jp3.value
        : assessment.parillo9
        ? bFPMapping.caliperMethod.parillo9.value
        : bFPMapping.caliperMethod.jp7.value,
      ...(assessment.jp3 && assessment.jp3_measurements),
      ...(assessment.jp7 && assessment.jp7_measurements),
      ...(assessment.parillo9 && assessment.parillo9_measurements),
      textFatPercentage: assessment.body_fat_percentage_is_text
        ? assessment.body_fat_percentage
        : '',
      calculatedFatPercentage: assessment.body_fat_percentage_is_caliper
        ? assessment.body_fat_percentage
        : ''
    };
  };

  movementKeys = assessment => {
    return {
      ...this.movementValue('dowel_bodyweight_squat', assessment),
      ...this.movementValue('dowel_standing_shoulder_press', assessment),
      ...this.movementValue('dowel_standing_hip_hinge', assessment),
      ...this.movementValue('db_front_foot_elevated_split_squat', assessment),
      ...this.movementValue('ng_shoulder_width_lat_pull_down', assessment)
    };
  };

  movementValue = (movement, assessment) => {
    return {
      [movement]: {
        rating_measurement_unit: String(
          assessment[movement].rating_measurement_unit
        ),
        video: {
          url: assessment[movement].video_url_value,
          size: 0
        },
        dysfunction: assessment[movement].dysfunction
          ? {
              ...assessment[movement].dysfunction
                .split(',')
                .map(dys => (dys === '1' ? true : false))
            }
          : formValuesSchema[movement].dysfunction
      }
    };
  };

  render() {
    const { client, assessment, updateAssessment, history } = this.props;

    return (
      client &&
      assessment && (
        <AssessmentForm
          client={client}
          prevUrl={`/clients/${this.clientId}/assessments/${this.assessmentId}`}
          prevTitle={assessment.assessment_type}
          formInitVals={assessment && this.formInitVals(assessment)}
          submitAssessmentForm={updateAssessment}
          history={history}
        />
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client,
    assessment: state.assessmentsReducer.assessment
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history)),
    getAssessment: (assessmentId, history) =>
      dispatch(getAssessment(assessmentId, history)),
    updateAssessment: (assessment, history) =>
      dispatch(updateAssessment(assessment, history))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditAssessment);
